<template>
    <div>
        <!-- メインメニュー -->
        <v-navigation-drawer v-model="navBar" temporary fixed clipped app>
            <v-list class="pt-0" dense>
                <v-list-group sub-group value="true">
                    <template v-slot:activator>
                        <v-list-item-title>アルバム制作</v-list-item-title>
                    </template>
                    <v-list-item to="/inhouse/albums" @click="clickNavBarMenu">
                        <v-list-item-icon>
                            <v-icon>photo_library</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>アルバム一覧</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="items.length">
                        <v-treeview :style="{ maxWidth: '216px' }" dense hoverable activatable
                            :load-children="fetchShootings" :items="items" @update:active="treeviewNodeClicked" />
                    </v-list-item>
                </v-list-group>

                <v-list-group sub-group value="true">
                    <template v-slot:activator>
                        <v-list-item-title>管理</v-list-item-title>
                    </template>
                    <v-list-item to="/inhouse/customers" @click="clickNavBarMenu">
                        <v-list-item-icon>
                            <v-icon>domain</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>学校管理</v-list-item-title>
                    </v-list-item>
                    <v-list-item to="/inhouse/settings" @click="clickNavBarMenu">
                        <v-list-item-icon>
                            <v-icon>settings</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>システム設定</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openOnlineManual">
                        <v-list-item-icon>
                            <v-icon>mdi-file-document-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>マニュアルを開く</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="toggleTheme">
                        <v-list-item-icon>
                            <v-icon>mdi-theme-light-dark</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            テーマ切替
                        </v-list-item-title>
                    </v-list-item>
                </v-list-group>
                <v-list-item @click="logout" style="padding-left: 24px;">
                    <v-list-item-icon style="margin: 8px 16px 8px 0;">
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        ログアウト
                    </v-list-item-title>
                </v-list-item>

            </v-list>
        </v-navigation-drawer>
        <!-- メインヘッダ -->
        <v-app-bar clipped-left fixed app color="secondary" elevate-on-scroll elevation="25">
            <v-app-bar-nav-icon @click.stop="navBar = !navBar">
                <v-icon style="color: #FFFFFF !important;">menu</v-icon>
            </v-app-bar-nav-icon>
            <v-container fluid class="ma-0 pa-0">
                <v-row justify="space-between">
                    <v-col class="ma-0 pa-0" style="display: flex; align-items: center;">
                        <v-container class="ma-0 pa-0">
                            <v-row style="display: flex; align-items: center;">
                                <v-col class="ma-0 pa-0" cols="6">


                                    <v-breadcrumbs :items="$root.$data.breadcrumbs">
                                        <template v-slot:divider>
                                            <v-icon>keyboard_arrow_right</v-icon>
                                        </template>
                                        <template v-slot:item="{ item }">
                                            <v-breadcrumbs-item v-if="item.text" class="no-underline-breadcrumbs"
                                                :href="item.href" :disabled="item.disabled">
                                                <span :title="item.text"
                                                    style="color: #FFFFFF; text-align: start; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 20vw;">
                                                    <p style="font-size: 10px; margin: 0; padding-left: 4px;">
                                                        {{ item.customer_text }}
                                                    </p>
                                                    {{ item.text }}
                                                </span>
                                            </v-breadcrumbs-item>
                                            <v-breadcrumbs-item v-else class="no-underline-breadcrumbs" :href="item.href"
                                                :disabled="item.disabled">
                                                <div v-for="(text, index) in item.texts" :key="index"
                                                    class="d-inline-flexs">
                                                    <icon-sex-ratio v-if="text.type == 'iconSexRatio'"
                                                        v-bind="text.value" />
                                                    <span v-else class="mr-1" style="color: #FFFFFF;">
                                                        {{ text.value }}
                                                    </span>
                                                </div>
                                            </v-breadcrumbs-item>
                                        </template>
                                    </v-breadcrumbs>
                                </v-col>
                                <v-col class="ma-0 pa-0" cols="6">
                                    <div style="display: flex; align-items: flex-end;　height: 64px;">
                                        <img v-if="$root.$data.step == '顔マスタ作成待ち'"
                                            style="height: 52px; width: 447px; margin-left: 20px;" src="/images/step.png" />
                                        <img v-else-if="$root.$data.step == 'アップロード待ち'"
                                            style="height: 52px; width: 447px; margin-left: 20px;"
                                            src="/images/step2.png" />
                                        <img v-else-if="$root.$data.step == 'AI処理待ち'"
                                            style="height: 52px; width: 447px; margin-left: 20px;"
                                            src="/images/step3.png" />
                                        <img v-else-if="$root.$data.step == '選定中'"
                                            style="height: 52px; width: 447px; margin-left: 20px;"
                                            src="/images/step4.png" />
                                    </div>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-col>
                    <v-col class="ma-0 pa-0" style="display: flex; align-items: center">
                        <v-container class="pa-4">
                            <v-row justify="end" style="margin-right: 0;">
                                <v-toolbar-items v-for="action in $root.$data.headerActions" :key="action.name"
                                    @click="action.consumer">
                                    <icon-with-text v-if="!!action.icon" :text="action.name" :show-text="action.showText"
                                        :badge-attrs="action.badgeAttrs" icon style="ma-0; color: #FFFFFF !important;"
                                        :icon-name="action.icon" :header-color="action.color" />
                                    <div v-else-if="!!action.imgSrc" v-bind="action.badgeAttrs" class="hover-pointer"
                                        style="display: flex; flex-direction: column; align-items: center; color: #FFFFFF !important; margin-left: 12px; position: relative;">
                                        <img v-if="!!action.imgSrc"
                                            style="width: 21px; height: 19px; color: #FFFFFF !important;"
                                            :src=action.imgSrc />
                                        <span v-if="$root.$data.faceCount > 0 && action.name == '顔マスタ'" style="position: absolute; top: -5px; right: -8px; min-width: 14px; height: 14px; 
               padding: 0 4px; background: #FFF; color: #0f68b1; font-size: 10px; 
               border-radius: 10px; display: flex; align-items: center; justify-content: center;">
                                            {{ $root.$data.faceCount }}
                                        </span>
                                        <span v-if="!$root.$data.faceCount && action.name == '顔マスタ'"
                                            style="position: absolute; top: 20px; right: -4px; width: 6px; height: 6px; background: red; border-radius: 50%;"></span>
                                        {{ action.name }}
                                    </div>
                                    <v-btn v-else small class="ma-1" color="quaternary">
                                        {{ action.name }}
                                    </v-btn>
                                </v-toolbar-items>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
            </v-container>
        </v-app-bar>
    </div>
</template>

<script>
import http from '../services/http';
import event from '../utils/event';
import urlUtil from '../utils/url';

export default {
    components: {
        'icon-with-text': require('./Icons/IconWithText.vue').default,
        'icon-sex-ratio': require('./Icons/IconSexRatio.vue').default,
    },
    data() {
        return {
            httpState: http.state,
            navBar: false,
            items: [],
            shootings: [],
            albumId: undefined,
        };
    },
    created() {
        event.on('albumSelected', (album) => {
            this.albumId = album.id;
            this.items.push({
                // クリックイベントの識別用 微妙...
                id: 'albumTitle',
                name: album.name,
                children: this.shootings,
            });
        });

        event.on('albumDisselected', () => {
            this.items = [];
        });
    },
    methods: {
        clickNavBarMenu() {
            this.navBar = false;
        },
        treeviewNodeClicked(activeNodes) {
            if (!activeNodes[0]) {
                return;
            } else if (activeNodes[0] == 'albumTitle') {
                // アルバムのタイトル部分がクリックされた場合は撮影行事一覧に飛ばす
                event.emit('orderedToOpenShootings');
            } else {
                event.emit('orderedToOpenShooting', activeNodes[0]);
            }
        },
        fetchShootings() {
            return http.backGroundRequest('get', (url => {
                url = urlUtil.addQueryParamIfDefined(url, 'album_id', this.albumId);

                return url;
            })('shootings'))
                .then((res) => {
                    this.items[0].children = res.data.map((shooting) => {
                        return {
                            id: shooting.id,
                            name: shooting.name,
                        };
                    });
                });
        },
        openOnlineManual() {
            window.open('/アルバム選考システム操作マニュアルver3.pdf', '_blank');
        },
        toggleTheme() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        },
        logout() {
            http
                .logout()
                .then(() => {
                    this.showMessage = '';
                    location.href = '/login';
                })
                .catch((error) => {
                    if (error == 'unauthorized') {
                        this.showMessage = 'ログアウトに失敗しました。';
                    } else {
                        this.showMessage = error;
                    }
                });
        },
    }
};
</script>

<style scoped>
.v-treeview-node__level {
    width: 12px !important;
}

.no-underline-breadcrumbs {
    color: #FFFFFF !important;
}

.no-underline-breadcrumbs>>>a:not(:hover) {
    text-decoration: none !important;
}

.hover-pointer:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.3);
}
</style>